<a routerLink="/">
  <img src="../../assets/logowhite.svg" alt="dots n pix logo" id="logoSmall">
</a>

<h1>Partners</h1>
<p>These are our partners. We're very thankful to have them. Without these partners, organizing an event with the scale of Dots 'n Pix would be unthinkable. They provided us this opportunity to help you learn, discover and innovate with the help of our amazing speakers.</p>
<div class="footer" id="sponsors">
    <img src="../../assets/sponsors/bxl.png" alt="">
    <img src="../../assets/sponsors/cegeka.png" alt="">
    <img src="../../assets/sponsors/cronos.png" alt="">
    <img src="../../assets/sponsors/ehb.png" alt="">
    <img src="../../assets/sponsors/flanders.png" alt="">
    <img src="../../assets/sponsors/imec.png" alt="">
    <img src="../../assets/sponsors/meetdistrict.png" alt="">
    <img src="../../assets/sponsors/overheid.png" alt="">
    <img src="../../assets/sponsors/showpad.png" alt="">
    <img src="../../assets/sponsors/voka.png" alt="">
</div>
